/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */
import axios from "axios";
import { baseApiV3_2, baseApiV3_3, baseApiV3_4 } from "../../constants/Presets";
import {
  AD_FRAMEWORK_TYPE,
  API_TYPE,
  APPLICATION_TYPE,
} from "../../app/Constants/Constants";

export function FetchCollectorMgmtList(payload) {
  return axios({
    method: "get",
    url: `${baseApiV3_3}collector/list`,
    params: {
      query: payload?.query ? payload.query : undefined,
    },
  });
}
export function FetchACollectorLogs(collector) {
  return axios({
    method: "get",
    url: `${baseApiV3_2}collector/changeLog/${collector.id}?resourceType=${collector.type}`,
  });
}
export function FetchACollectorMgmt(collector) {
  return axios({
    method: "get",
    url:
      collector.type !== AD_FRAMEWORK_TYPE
        ? `${baseApiV3_3}collector/details/${collector.id}`
        : `${baseApiV3_3}collector/get_framework_information/${collector.id}`,
  });
}
export function FetchImage(url) {
  return axios({
    method: "get",
    url: url,
  });
}

export function CreateCollectorMgmtJira(payload) {
  return axios({
    method: "post",
    url: `${baseApiV3_3}collector/createJira`,
    data: payload,
  });
}
export function CreateCollector(collector) {
  return axios({
    method: "post",
    url: `${baseApiV3_2}collector`,
    data: collector,
  });
}

export function UpdateCollectorMgmt(payload) {
  let dataToSend = payload.collector;
  const isFormData = Boolean(payload.collector?.collectorImage); // Check if FormData is needed
  if (isFormData) {
    dataToSend = new FormData();
    Object.entries(payload.collector).forEach(([key, value]) => {
      dataToSend.append(key, value);
    });
  }
  const url =
    payload.type === "application" || payload.type === "api"
      ? `${baseApiV3_4}collector`
      : `${baseApiV3_4}collector/component`;
  return axios.patch(url, dataToSend, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function CreateAdFramework(collector) {
  return axios({
    method: "post",
    url: `${baseApiV3_3}collector/component`,
    data: collector,
  });
}

export function FetchsupportedDataPoints(payload) {
  let url;
  url = `${baseApiV3_3}collector/datapoints/${payload?.playerId}?`;
  const params = [];
  params.push(`order=${payload?.order}`);
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const query = payload?.query || "";
  params.push(`query=${encodeURIComponent(query)?.toString()}`);
  const order_by = payload?.order_by || "name";
  params.push(`order_by=${order_by}`);
  params.push("size=1000");
  const resourceType = payload?.resourceType;
  params.push(`resource_type=${resourceType}`);
  const filter =
    payload?.filters && Object.keys(payload?.filters).length > 0
      ? encodeURIComponent(JSON.stringify(payload.filters))
      : null;
  if (filter) {
    params.push(`filters=${filter}`);
  }
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}

export function AuthorOrUnauthorDataPoint(data) {
  return axios({
    method: "post",
    url: `${baseApiV3_3}collector/authorize`,
    data,
  });
}
